import { isEmpty } from '@adex/shared/utils/data'


export function centToString(cent) {
  const dollars = `${ cent / 100 }`.split('.')
  const res = []
  const wholePart = dollars[0]
  let decimalPart = dollars[1]
  res.push(bigNumberToView(wholePart))
  if (!isEmpty(decimalPart)) {
    if (decimalPart.length < 2) decimalPart = decimalPart + '0'
    res.push(decimalPart)
  }
  return res.join('.')
}

export function bigNumberToView(value) {
  const normalValue = `${ value }`
  if (normalValue.length <= 3) return normalValue
  if (normalValue.split('.').length > 1) throw new Error('function bigNumberToView only accepts integers, you input ' + normalValue)
  let newStr = ''
  const isNegative = normalValue[0] === '-'
  const cArr = normalValue
    .replace('-', '')
    .split('')
    .reverse()
  for (let i = cArr.length - 1; i >= 0; i--) {
    const c = cArr[i]
    newStr = newStr + c
    if (i % 3 === 0 && i !== 0) newStr = newStr + ','
  }
  if (isNegative) newStr = '-' + newStr
  return newStr
}
